import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { NAV } from "../constants/testIds";
import { Globe } from "lucide-react";

export const LanguageSelector = ({ scope = "nav" }) => {
  const { locale, setLocale, locales } = useI18n();
  const current = locales.find((l) => l.code === locale) || locales[1];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={`${NAV.languageSelector}-${scope}`}
          className="inline-flex items-center gap-2 px-3 py-2 text-[11px] tracking-[0.22em] uppercase text-white/70 hover:text-white border border-white/10 hover:border-white/30 transition-colors"
          aria-label="Select language"
        >
          <Globe size={13} strokeWidth={1.5} />
          <span className="font-mono">{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        className="min-w-[180px] bg-black border border-white/15 rounded-none p-0 text-white"
      >
        {locales.map((l) => {
          const active = l.code === locale;
          return (
            <DropdownMenuItem
              key={l.code}
              data-testid={`${NAV.languageOption(l.code)}-${scope}`}
              onSelect={() => setLocale(l.code)}
              className={
                "flex items-center justify-between cursor-pointer rounded-none px-4 py-3 text-[12px] tracking-[0.16em] uppercase font-mono " +
                "focus:bg-white focus:text-black " +
                (active ? "text-white" : "text-white/60")
              }
            >
              <span>{l.label}</span>
              <span className="text-[11px] tracking-[0.04em] normal-case font-body opacity-80">{l.full}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
